import useRedux from 'hooks/useRedux'
import { ListaParcela, ProdutosSimulacao } from 'models/types'
import React, { useEffect, useState } from 'react'
import { Col, Row, FormGroup, Label, Card } from 'reactstrap'
import { maskMoney } from 'util/masks'
import { ContentCardCrefaz, CustomRadioButton, ParcelaItem } from '../../style'
import CustomSelect from 'components/Select'
import InputCustom from 'components/Inputs'
import * as simulacaoActions from 'store/modules/simulacao/actions'
import SimpleModal from 'components/SimpleModal'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import FeaturedIcon from 'assets/images/featured-icon.png'
import { ApplicationState } from 'store'
import { SIMULACAO } from 'store/modules/simulacao/types'
import { useSelector } from 'react-redux'

interface DetalhamentoEmprestimoCrefazProps {
  simulacao: ProdutosSimulacao
  produtoId: number
  isOpen: boolean
  toggle: () => void
}

export default function ModalDetalhamentoEmprestimoCrefaz({
  simulacao,
  produtoId,
  isOpen,
  toggle
}: DetalhamentoEmprestimoCrefazProps) {
  const { produtosSelecionados } = useSelector<ApplicationState, SIMULACAO>(
    (state) => state.simulacao
  )
  const [produtoIndex, setProdutoIndex] = useState<number | undefined>()
  const [convenioIndex, setConvenioIndex] = useState<number | undefined>()
  const [valoresSolicitados, setValoresSolicitados] = useState(() => {
    return simulacao.simulacoesCrefaz?.[
      produtoIndex ?? 0
    ]?.empresasConveniadas?.[0].listaValoresLiberados
      .map((item) => {
        return {
          valor: item?.valor || 0,
          descricao: maskMoney(item?.valor?.toFixed(2))
        }
      })
      .sort((a, b) => b.valor - a.valor)
  })
  const [prazos, setPrazos] = useState<ListaParcela[]>([])

  useEffect(() => {
    const newProdutoIndex = simulacao.simulacoesCrefaz?.findIndex(
      (simulacaoCrefaz) => simulacaoCrefaz.produtoId === produtoId
    )

    setProdutoIndex(newProdutoIndex)

    const newConvenioIndex = simulacao.simulacoesCrefaz?.[
      newProdutoIndex ?? 0
    ]?.empresasConveniadas.findIndex(
      (s) =>
        s.convenioId ===
        simulacao.simulacoesCrefaz?.[produtoIndex ?? 0]?.selecionados.convenioId
    )

    setConvenioIndex(newConvenioIndex)

    const newValoresSolicitados =
      simulacao.simulacoesCrefaz?.[newProdutoIndex ?? 0]?.empresasConveniadas?.[
        newConvenioIndex ?? 0
      ]?.listaValoresLiberados
        .map((item) => {
          return {
            valor: item?.valor || 0,
            descricao: maskMoney(item?.valor?.toFixed(2))
          }
        })
        .sort((a, b) => b.valor - a.valor) ?? []

    setValoresSolicitados(newValoresSolicitados)

    const newPrazos =
      simulacao.simulacoesCrefaz?.[newProdutoIndex ?? 0].empresasConveniadas?.[
        newConvenioIndex ?? 0
      ]?.listaValoresLiberados.find(
        (valorLiberado) =>
          valorLiberado.valor ===
          simulacao.simulacoesCrefaz?.[produtoIndex ?? 0].selecionados
            .valorSolicitado
      )?.listaParcelas ?? []

    const sortedPrazos = newPrazos.sort((a, b) => b.prazo - a.prazo)
    setPrazos(sortedPrazos)
    /* eslint-disable */
  }, [
    simulacao,
    produtoId,
    produtoIndex,
    simulacao.simulacoesCrefaz?.[produtoIndex ?? 0].selecionados
      .valorSolicitado,
    simulacao.simulacoesCrefaz?.[produtoIndex ?? 0].selecionados.convenioId
  ])
  /* eslint-enable */

  const { dispatch } = useRedux()

  const verificaOutrosProdutosCrefazInvalidos = () => {
    const isCrefazInvalido = (produto: ProdutosSimulacao) =>
      produto.servico === 13 &&
      produto.simulacoesCrefaz?.some(
        (p) =>
          p.selecionados.convenioDados.some((c) => c.valor === null) ||
          p.selecionados.valorParcela === null ||
          p.selecionados.prazo === null
      )

    if (produtosSelecionados.some(isCrefazInvalido)) {
      const crefazInvalidoIndex =
        produtosSelecionados.findIndex(isCrefazInvalido)
      const convenioDadosCrefazInvalidoIndex = produtosSelecionados[
        crefazInvalidoIndex
      ]?.simulacoesCrefaz?.findIndex(
        (simulacao) =>
          simulacao.selecionados.convenioDados.some((c) => c.valor === null) ||
          simulacao.selecionados.valorParcela === null ||
          simulacao.selecionados.prazo === null
      )

      const produtoSelecionado = produtosSelecionados[crefazInvalidoIndex]

      dispatch(
        simulacaoActions.selectProduto({
          servico: produtoSelecionado.servico,
          matricula: produtoSelecionado.matricula ?? '',
          produtoCrefazId:
            produtoSelecionado.simulacoesCrefaz?.[
              convenioDadosCrefazInvalidoIndex ?? 0
            ].produtoId
        })
      )
      return true
    }
    return false
  }

  return (
    <SimpleModal
      toggle={() => toggle()}
      isOpen={isOpen}
      size="lg"
      header={
        <SimpleTitleCard>
          <img src={FeaturedIcon} alt="Ícone" />
          Preencha as informações para consultar os valores disponíveis
        </SimpleTitleCard>
      }
      dataBackdrop="static"
    >
      <ContentCardCrefaz>
        <div className="d-flex flex-column w-100 row-gap-20">
          <Row>
            <Col lg={6}>
              <Label className="fw-bolder">Empresa Conveniada</Label>
              <CustomSelect
                isClearable={false}
                options={
                  simulacao.simulacoesCrefaz?.[produtoIndex ?? 0]
                    .empresasConveniadas ?? []
                }
                value={
                  simulacao.simulacoesCrefaz?.[produtoIndex ?? 0].selecionados
                    .convenioId ?? ''
                }
                onChange={(e) => {
                  dispatch(
                    simulacaoActions.setInfosCrefaz({
                      value: e,
                      field: 'convenioId',
                      indexProduto: produtoIndex ?? 0
                    })
                  )
                }}
                accessorLabel="descricao"
                accessorValue="convenioId"
              />
            </Col>
            <Col lg={6}>
              <Label className="fw-bolder">Valor Solicitado</Label>
              <CustomSelect
                isClearable={false}
                options={valoresSolicitados || []}
                value={
                  simulacao.simulacoesCrefaz?.[produtoIndex ?? 0].selecionados
                    .valorSolicitado || ''
                }
                onChange={(e) => {
                  dispatch(
                    simulacaoActions.setInfosCrefaz({
                      value: e,
                      field: 'valorSolicitado',
                      indexProduto: produtoIndex ?? 0
                    })
                  )
                  const newPrazos =
                    simulacao.simulacoesCrefaz?.[
                      produtoIndex ?? 0
                    ].empresasConveniadas?.[
                      convenioIndex ?? 0
                    ].listaValoresLiberados.find(
                      (valorLiberado) =>
                        valorLiberado.valor ===
                        simulacao.simulacoesCrefaz?.[produtoIndex ?? 0]
                          .selecionados.valorSolicitado
                    )?.listaParcelas ?? []

                  const maiorPrazo = newPrazos.reduce(
                    (max, item) => (item.prazo > max.prazo ? item : max),
                    newPrazos[0]
                  )

                  dispatch(
                    simulacaoActions.setInfosCrefaz({
                      value: maiorPrazo.prazo,
                      field: 'prazo',
                      indexProduto: produtoIndex ?? 0
                    })
                  )
                  dispatch(
                    simulacaoActions.setInfosCrefaz({
                      value: maiorPrazo.valor,
                      field: 'valorParcela',
                      indexProduto: produtoIndex ?? 0
                    })
                  )
                }}
                accessorLabel="descricao"
                accessorValue="valor"
              />
            </Col>
          </Row>
          <Row className="row-gap-15">
            <Col className="d-flex flex-column row-gap-15" xl={6}>
              {simulacao.simulacoesCrefaz?.[
                produtoIndex ?? 0
              ].empresasConveniadas[convenioIndex ?? 0]?.convenioDados.map(
                (dado, i) => {
                  return (
                    <Row key={i}>
                      <Col>
                        <Label className="fw-bolder">{dado.descricao} *</Label>
                        <InputCustom
                          type={
                            dado.descricao.toLowerCase().includes('data')
                              ? 'date'
                              : 'text'
                          }
                          value={
                            simulacao.simulacoesCrefaz?.[produtoIndex ?? 0]
                              .selecionados.convenioDados[i]?.valor
                          }
                          onChange={(e) => {
                            dispatch(
                              simulacaoActions.setInfosConvenioDadosCrefaz({
                                value: e.target.value,
                                field: 'valor',
                                indexProduto: produtoIndex ?? 0,
                                indexConvenioDado: i
                              })
                            )
                          }}
                          placeholder="Digite"
                        />
                      </Col>
                    </Row>
                  )
                }
              )}
            </Col>
            <Col xl={6}>
              {prazos?.length > 0 && (
                <Card className="p-3 shadow-sm">
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="fw-bolder">Prazo</Label>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="fw-bolder">Valor da Parcela</Label>
                      </FormGroup>
                    </Col>
                    {prazos.map((parcela, i) => (
                      <React.Fragment key={i}>
                        <Col className="d-flex align-items-center" xs={6}>
                          <FormGroup>
                            <ParcelaItem>
                              <CustomRadioButton
                                type="radio"
                                name={`prazo-${produtoIndex}-${0}-${i}`}
                                value={parcela.prazo}
                                checked={
                                  simulacao.simulacoesCrefaz?.[
                                    produtoIndex ?? 0
                                  ].selecionados.prazo === parcela.prazo
                                }
                                onClick={() => {
                                  dispatch(
                                    simulacaoActions.setInfosCrefaz({
                                      value: parcela.prazo,
                                      field: 'prazo',
                                      indexProduto: produtoIndex ?? 0
                                    })
                                  )
                                  dispatch(
                                    simulacaoActions.setInfosCrefaz({
                                      value: parcela.valor,
                                      field: 'valorParcela',
                                      indexProduto: produtoIndex ?? 0
                                    })
                                  )
                                }}
                              />
                              <Label
                                className="mb-0"
                                htmlFor={`prazo-${produtoIndex}-${0}-${i}`}
                              >
                                {parcela.prazo} meses
                              </Label>
                            </ParcelaItem>
                          </FormGroup>
                        </Col>
                        <Col className="d-flex align-items-center" xs={6}>
                          <FormGroup>
                            <ParcelaItem>
                              <span>R$ {parcela.valor.toFixed(2)}</span>
                            </ParcelaItem>
                          </FormGroup>
                        </Col>
                      </React.Fragment>
                    ))}
                  </Row>
                </Card>
              )}
            </Col>
          </Row>
          <div className="d-flex justify-content-evenly flex-wrap gap-3">
            <CustomButton
              background="var(--verde-riber)"
              onClick={() => {
                dispatch(
                  simulacaoActions.recalculoCrefazSaga(
                    produtoIndex ?? 0,
                    convenioIndex ?? 0
                  )
                )
              }}
            >
              Calcular
            </CustomButton>

            <CustomButton
              background="var(--roxo-riber)"
              onClick={() => {
                if (!verificaOutrosProdutosCrefazInvalidos()) {
                  toggle()
                  dispatch(simulacaoActions.toggleModalUploadCrefaz(true))
                }
              }}
              disabled={
                !simulacao.simulacoesCrefaz?.[produtoIndex ?? 0].selecionados
                  .prazo
              }
            >
              Avançar
            </CustomButton>
          </div>
        </div>
      </ContentCardCrefaz>
    </SimpleModal>
  )
}
